import { Reducer } from 'redux';
import { IProfileState, ProfileActionEnum, ProfileActions } from '.';
import {
  IProfile
} from '../../services';


export const initialState: IProfileState = {
  loading: true,
  profile: {} as IProfile | undefined,
  exceptionMessage: "",
  message: "",
};

export const profileReducer: Reducer<IProfileState, ProfileActions> = (
    state = initialState,
    action: ProfileActions
) => {
  switch (action.type) {
    case ProfileActionEnum.FetchProfile:
      return {
        ...state,
        loading: true,
      };
    case ProfileActionEnum.FetchProfileSuccess:
      return {
        ...state,
        loading: false,
        profile: action.state?.profile,
      };
    case ProfileActionEnum.FetchProfileFailed:
      return {
        ...state,
        loading: false,
        exceptionMessage: action.state?.exceptionMessage,
      };

    default:
      return state;
  }
};
